import '../assets/NcCheckboxRadioSwitch-DArK1Q95.css';
import { r as register } from "./_l10n-hRR5zBTZ.mjs";
register();
